import { observer } from 'mobx-react-lite';
import LeftPanel from './LeftPanel';
import { LeftPanelProps, LeftPanelValueProps } from './types';

export type { LeftPanelProps, LeftPanelValueProps };
export default observer(LeftPanel); // MANUAL OVERRIDE
